let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gyCjO")).then(() => parcelRequire('6nzR8'));